import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import InputOTP from "./InputOtp";
import Button from "../../components/ui/Button";

const VerificationModal = ({ isOpen, onClose }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (newOtp[index] !== "") {
        newOtp[index] = "";
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
      }

      setOtp(newOtp);
    }
  };

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <motion.div
          key={isOpen}
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="bg-white p-6 md:p-8 rounded-3xl w-full max-w-sm md:max-w-md lg:max-w-lg shadow-lg"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900">
              Masukkan Kode OTP untuk Verifikasi Akun Kamu
            </h2>
            <p className="text-gray-500 text-center mt-2 text-sm md:text-base">
              Kami sudah mengirim kode OTP ke nomor <b>081234567890</b>. Silakan
              masukkan kode tersebut di bawah ini.
            </p>

            {/* Input OTP */}
            <div className="flex justify-center gap-2 md:gap-3 mt-6">
              {otp.map((_, index) => (
                <InputOTP
                  key={index}
                  index={index}
                  onChange={handleChange}
                  onKeyDown={handleOtpKeyDown}
                  ref={(el) => (inputRefs.current[index] = el)}
                />
              ))}
            </div>

            {/* Tombol Verifikasi */}
            <div className="mt-6 md:mt-8">
              <Button
                text="Verifikasi Sekarang"
                fullWidth={true}
                className="w-full bg-green-500 text-white text-sm md:text-lg py-2 md:py-3 rounded-lg"
              />
            </div>

            {/* Link Kirim Ulang OTP */}
            <p className="text-center text-gray-500 mt-4 text-sm md:text-base">
              Belum dapat kode?{" "}
              <a href="#" className="text-blue-500 font-medium">
                Kirim ulang OTP
              </a>
            </p>

            {/* Close button */}
            <button
              onClick={onClose}
              className="mt-4 text-gray-400 text-xs md:text-sm underline w-full text-center"
            >
              Tutup
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VerificationModal;
